import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  previewBox: {
    fontSize: 16,
    fontFamily: 'Arial, sans-serif !important',
    color: 'initial',
    overflowWrap: 'break-word',
    wordBreak: 'break-word',

    '& *': {
      fontFamily: 'Arial, sans-serif !important',
    },

    '& img': {
      maxWidth: '100%',
      height: 'auto',
    },

    '& table': {
      maxWidth: '100%',
      border: 'none',
      marginTop: '1em',
      marginBottom: '1em',
      borderCollapse: 'collapse',
      emptyCells: 'show',

      '& tr': {
        userSelect: 'none',

        '& th, & td': {
          minWidth: '2em',
          padding: '0.4em',
          border: `1px solid ${theme.palette.divider}`,
          userSelect: 'text',
          verticalAlign: 'middle',
        },
      },
    },
  },
}))
